// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7892) return "static/chunks/7892-6531a0252e12364c.js";
	if (chunkId === 9334) return "static/chunks/9334-3f20346fced2ee02.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2366":"476af50ec519cb5f","2655":"ce3656a64c8e6229","4363":"f21ac884234beaea","4776":"db37c79328815843","6793":"f57464ca23fa9330","8420":"f89191dae362e1cc","8765":"9d43e68265964f68"}[chunkId] + ".js";
};